import { UserPlus, CheckCircle2, Clock, PhoneCall, XCircle, MessageCircle, Phone } from "lucide-react";

var STATUS_MAP = {
  nova: { cls: "bg-blue-100 text-blue-700", label: "Nova", icon: Clock },
  atribuida: { cls: "bg-purple-100 text-purple-700", label: "Atribuida", icon: UserPlus },
  em_contato: { cls: "bg-amber-100 text-amber-700", label: "Em Contato", icon: PhoneCall },
  convertida: { cls: "bg-emerald-100 text-emerald-700", label: "Convertida", icon: CheckCircle2 },
  perdida: { cls: "bg-red-100 text-red-700", label: "Perdida", icon: XCircle },
};

function formatDate(d) {
  if (!d) return "-";
  try { return new Date(d).toLocaleDateString("pt-BR"); } catch(e) { return d; }
}

function cleanPhone(phone) {
  return (phone || "").replace(/\D/g, "");
}

export default function ReferralsSection({ referrals }) {
  if (!referrals || referrals.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-testid="profile-referrals-section">
        <h2 className="text-base font-bold text-[#0A2F3D] mb-3 flex items-center gap-2"><UserPlus className="w-5 h-5 text-purple-500" />Indicacoes Feitas</h2>
        <p className="text-sm text-gray-400 text-center py-6">Nenhuma indicacao registrada</p>
      </div>
    );
  }

  var convertedCount = referrals.filter(function(r) { return r.status === "convertida"; }).length;
  var pendingCount = referrals.filter(function(r) { return r.status === "nova" || r.status === "atribuida" || r.status === "em_contato"; }).length;

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-6" data-testid="profile-referrals-section">
      <h2 className="text-base font-bold text-[#0A2F3D] mb-2 flex items-center gap-2">
        <UserPlus className="w-5 h-5 text-purple-500" />Indicacoes Feitas
        <span className="ml-auto text-xs font-normal text-gray-400">{referrals.length} indicacao{referrals.length !== 1 ? "es" : ""}</span>
      </h2>
      {/* Funnel summary */}
      <div className="flex flex-wrap gap-3 mb-4">
        <span className="px-2.5 py-1 text-[10px] font-medium rounded-full bg-emerald-50 text-emerald-700" data-testid="referral-converted-count">
          {convertedCount} convertida{convertedCount !== 1 ? "s" : ""}
        </span>
        <span className="px-2.5 py-1 text-[10px] font-medium rounded-full bg-amber-50 text-amber-700" data-testid="referral-pending-count">
          {pendingCount} em andamento
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="profile-referrals-table">
          <thead>
            <tr className="border-b border-gray-100 bg-gray-50/50">
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Nome</th>
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Telefone</th>
              <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Interesse</th>
              <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Data</th>
              <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Contato</th>
            </tr>
          </thead>
          <tbody>
            {referrals.map(function(r) {
              var stInfo = STATUS_MAP[r.status] || { cls: "bg-gray-100 text-gray-600", label: r.status, icon: Clock };
              var Icon = stInfo.icon;
              var digits = cleanPhone(r.phone);
              return (
                <tr key={r.id} className="border-b border-gray-50 hover:bg-gray-50/50" data-testid={"profile-referral-" + r.id}>
                  <td className="py-2.5 px-3 font-medium text-[#0A2F3D]">{r.name}</td>
                  <td className="py-2.5 px-3 text-gray-500 hidden sm:table-cell">{r.phone || "-"}</td>
                  <td className="py-2.5 px-3 text-gray-500 hidden md:table-cell">{r.product_interest || "-"}</td>
                  <td className="py-2.5 px-3 text-center text-gray-400 hidden sm:table-cell">{formatDate(r.created_at)}</td>
                  <td className="py-2.5 px-3 text-center">
                    <span className={"px-2 py-0.5 text-xs font-medium rounded-full inline-flex items-center gap-1 " + stInfo.cls}>
                      <Icon className="w-3 h-3" />{stInfo.label}
                    </span>
                  </td>
                  <td className="py-2.5 px-3 text-center">
                    <div className="flex items-center justify-center gap-1.5">
                      {digits ? (
                        <>
                          <a href={"tel:" + digits} className="p-1.5 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-100 transition-colors" title="Ligar" data-testid={"referral-call-" + r.id}>
                            <Phone className="w-3.5 h-3.5" />
                          </a>
                          <a href={"https://wa.me/55" + digits} target="_blank" rel="noopener noreferrer"
                            className="p-1.5 rounded-lg bg-emerald-50 text-emerald-600 hover:bg-emerald-100 transition-colors" title="WhatsApp" data-testid={"referral-wpp-" + r.id}>
                            <MessageCircle className="w-3.5 h-3.5" />
                          </a>
                        </>
                      ) : (
                        <span className="text-xs text-gray-300">-</span>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
